import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { ShortDatePipe } from 'src/app/global/pipes/shortDate/short-date.pipe';
import { CardActions } from 'src/app/user/user.model';

@Component({
    selector: 'app-step-confirmation-not-connected',
    templateUrl: './confirmation-not-connected.component.html',
    styleUrls: ['./confirmation-not-connected.component.scss'],
})
export class StepConfirmationNotConnectedComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    @Input() form: FormGroup;
    @Input() instructionsStepsConfirmation: string;
    @Input() cardActions: CardActions;

    public hideExpDate = false;

    CardActions = CardActions;

    constructor(private translateService: TranslateService) {}

    get firstName() {
        return this.form.get('firstName').value;
    }
    get lastName() {
        return this.form.get('lastName').value;
    }
    get address() {
        return this.form.get('address').value;
    }
    get picture() {
        return this.form.get('picture').value;
    }
    get birthDate() {
        return this.formatDate(this.form.get('birthDate').value);
    }
    get sex() {
        return this.form.get('sex').value;
    }
    get attachments() {
        return this.form.get('attachments')?.value;
    }
    get subType() {
        return this.form.get('subType').value;
    }
    get cardNumber() {
        return this.form.get('cardNumber').value;
    }
    get expDate() {
        return this.formatExpDate(this.form.get('expDate').value || '');
    }

    ngOnInit(): void {}

    formatDate(date: string) {
        if (!date) {
            return '';
        }
        // Extract date portion from ISO string to avoid timezone conversion issues
        let dateString = date;
        if (date.includes('T')) {
            dateString = date.split('T')[0];
        }
        // Parse date components and create Date in local timezone
        const [year, month, day] = dateString.split('-').map(Number);
        const tempDate = new Date(year, month - 1, day);
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Intl.DateTimeFormat(`${this.translateService.currentLang}-CA`, options).format(tempDate);
    }

    formatExpDate(date: any): string {
        if (!date) return '';
        const shortDatePipe = new ShortDatePipe(this.translateService);
        return shortDatePipe.transform(date) || ''; // Ensure it returns a formatted string
    }

    urlIsImage(fileType: string) {
        return ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'].indexOf(fileType) > -1;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
